import { cart } from '@/lib/cart';
import { sleep } from '@/lib/utils';
import { Component, defineComponent } from '@decify/cell-shopify/client';
import { Button, buttonTagName } from '../Button';
import './ProductForm.scss';
export const productFormName = 'ProductForm';
export const productFormTagName = 'cell-component-product-form';
export const productFormAddedItemsEvent = 'addedItems';
export class ProductForm extends Component {
    elements;
    constructor() {
        super('ProductForm');
        this.validateProps(['completedAnimationVisible', 'completedAnimationDuration']);
        const formElement = this.querySelector('form');
        if (!formElement) {
            throw new Error('Form element not found');
        }
        this.elements = {
            form: formElement,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        this.elements.form.subscribe('submit', this.handleSubmit);
    }
    async handleSubmit(_, event) {
        event.preventDefault();
        this.resetError();
        this.buttonElement.setLoading(true);
        const formData = new FormData(this.elements.form);
        const id = formData.get('id');
        if (typeof id !== 'string') {
            throw new Error('Product variant ID not found');
        }
        let quantity = formData.get('quantity');
        if (typeof quantity !== 'string') {
            quantity = '1';
        }
        const formDataEntries = formData.entries();
        const properties = [...formDataEntries]
            .filter(([key]) => key.startsWith('properties'))
            .reduce((acc, [key, value]) => {
            const propertyKey = key.split('[')?.[1]?.split(']')?.[0];
            if (!propertyKey || typeof value !== 'string') {
                return acc;
            }
            return {
                ...acc,
                [propertyKey]: value,
            };
        }, {});
        const itemToAdd = {
            id: parseInt(id),
            quantity: parseInt(quantity),
            properties,
        };
        const response = await cart.addItems([itemToAdd]);
        this.buttonElement.setLoading(false);
        if (!response.success) {
            this.errorElement.text.textContent = response.error;
            this.errorElement.wrapper.removeAttribute('hidden');
            return;
        }
        if (this.props.completedAnimationVisible) {
            this.buttonElement.setCompleted(true);
            await sleep(this.props.completedAnimationDuration);
            this.buttonElement.setCompleted(false);
        }
        // TODO: Fix this type error.
        // @ts-ignore
        this.publish(productFormAddedItemsEvent, response.data);
    }
    resetError() {
        this.errorElement.text.textContent =
            this.errorElement.wrapper.getAttribute('data-error-template');
        this.errorElement.wrapper.setAttribute('hidden', 'hidden');
    }
    get buttonElement() {
        const buttonElement = this.querySelector(buttonTagName);
        if (!buttonElement || !(buttonElement instanceof Button)) {
            throw new Error('Button element not found');
        }
        return buttonElement;
    }
    get errorElement() {
        const wrapperElement = this.querySelector('.ProductForm__Error');
        const textElement = wrapperElement?.children[0];
        if (!wrapperElement || !textElement) {
            throw new Error('Error element not found');
        }
        return {
            wrapper: wrapperElement,
            text: textElement,
        };
    }
}
defineComponent('cell-component-product-form', ProductForm);
